import * as propertyTypes from "../property_types.js"

export class UiMultipleRadiobuttonsProps extends propertyTypes.AppBaseComponentProps {

    private dataSourceUrlMetadata = new propertyTypes.TextProperty("dataSourceUrl", "Datasource url");
    public dataSourceUrl: string;

    private dataTextFieldMetadata = new propertyTypes.TextProperty("dataTextField", "Data text field");
    public dataTextField: string;

    private dataValueFieldMetadata = new propertyTypes.TextProperty("dataValueField", "Data value field");
    public dataValueField: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.dataSourceUrlMetadata, this.dataTextFieldMetadata, this.dataValueFieldMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}